export default "__VITE_ASSET__bvP8cJdO__"